/**
 * 'Chartjs.config'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

const backgroundColors = [
  'rgba(196, 18, 48, 0.1)',
  'rgba(0, 0, 0, 0.03)'
]

const borderColors = [
  'rgba(196, 18, 48, 1)',
  'rgba(0, 0, 0, 0.3)'
]

export {
  backgroundColors,
  borderColors
}



// WEBPACK FOOTER //
// ./src/config/chartjs.config.js